function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes, { string } from 'prop-types';
import { AddMoreImagesStyles, ArrowStyles, CardContainerStyles, DialogContainerStyles, IconContainer, ImagesContainer, ImageStyles, ImageStylesContainer, InputFileHiddenStyles, InputImageContainer, LeftSideContainer, RemoveImageStyles, VisualizationImagesArrowsContainer, VisualizationImagesSelection, VisualizationImagesStyles, VisualizationStyles } from './InputImage.styles';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import Button from '../Button/Button';
import Alert from '../Alert/Alert';
import Dialog from '../Dialog/Dialog';
import Card from '../Card/Card';
import Pagination from '../Pagination/Pagination';
import Tooltip from '../Tooltip/Tooltip';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InputImage = function InputImage(props) {
  var _useState = useState([]),
    images = _useState[0],
    setImages = _useState[1];
  var _useState2 = useState(),
    currentImageIndex = _useState2[0],
    setCurrentImageIndex = _useState2[1];
  var _useState3 = useState(),
    error = _useState3[0],
    setError = _useState3[1];
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  var isDesktop = useMediaQuery({
    query: theme.breakpoints.desktop
  });
  var inputFileRef = useRef();
  var title = props.title,
    maxFileSize = props.maxFileSize,
    maxFileSizeErrorText = props.maxFileSizeErrorText,
    dataTestId = props.dataTestId,
    allowMultipleImages = props.allowMultipleImages,
    acceptedFormats = props.acceptedFormats,
    acceptedFormatsErrorText = props.acceptedFormatsErrorText,
    onChange = props.onChange,
    maxFiles = props.maxFiles,
    maxFilesErrorText = props.maxFilesErrorText;
  useEffect(function () {
    if (onChange) {
      onChange(images);
    }
  }, [images, onChange]);
  var handleClick = function handleClick() {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };
  var extractFormatsText = function extractFormatsText(array) {
    var formattedFormats = array.map(function (format) {
      return format.toUpperCase();
    });
    if (formattedFormats.length <= 2) {
      return formattedFormats.join(' ou ');
    }
    var lastFormat = formattedFormats.pop();
    return formattedFormats.join(', ') + " ou " + lastFormat;
  };
  var toBase64 = function toBase64(data) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      if (data) {
        reader.readAsDataURL(data);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (err) {
          return reject(err);
        };
      }
    });
  };
  var imageIsValidated = function imageIsValidated(file) {
    if (!file) {
      setError({
        title: 'Não foi possível adicionar imagem',
        message: "Por favor, tente novamente mais tarde. \n        Se o problema persistir, entre em contato com o nosso suporte."
      });
      return false;
    }
    var split = file.name.split('.');
    var extension = split[split.length - 1].toLowerCase();
    if (!acceptedFormats.includes(extension)) {
      setError({
        title: 'Este formato não é permitido',
        message: acceptedFormatsErrorText || "Um ou mais arquivos selecionados est\xE3o com o \n        formato incompat\xEDvel. Por favor, selecione imagens em \n        " + extractFormatsText(acceptedFormats) + "."
      });
      return false;
    }
    var fileSize = file.size / 1024 / 1024;
    if (fileSize > maxFileSize) {
      setError({
        title: 'Tamanho máximo atingido',
        message: maxFileSizeErrorText || "Um ou mais arquivos que voc\xEA selecionou s\xE3o muito \n        grandes para carregar. Selecione uma imagem com menos de \n        " + maxFileSize + " MB."
      });
      return false;
    }
    return true;
  };
  var addImage = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(fileList) {
      var filesArray;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            filesArray = Array.from(fileList);
            if (!(filesArray.length + images.length > maxFiles)) {
              _context2.next = 4;
              break;
            }
            setError({
              title: 'Número máximo de imagens excedido',
              message: maxFilesErrorText || "Voc\xEA pode adicionar no m\xE1ximo " + maxFiles + " \n        imagens. Por favor, reduza a quantidade e \n        tente novamente."
            });
            return _context2.abrupt("return");
          case 4:
            filesArray.forEach( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
                var base64;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!imageIsValidated(file)) {
                        _context.next = 5;
                        break;
                      }
                      _context.next = 3;
                      return toBase64(file);
                    case 3:
                      base64 = _context.sent;
                      setImages(function (prevImages) {
                        return [].concat(prevImages, [{
                          name: file.name,
                          src: base64
                        }]);
                      });
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
            if (inputFileRef.current) {
              inputFileRef.current.value = '';
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function addImage(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var removeImage = function removeImage(e, index) {
    e.stopPropagation();
    setImages(function (prevImages) {
      return prevImages.filter(function (item, i) {
        return i !== index;
      });
    });
  };
  var openVisualization = function openVisualization(index) {
    setCurrentImageIndex(index);
  };
  var renderVisualizationDialog = function renderVisualizationDialog() {
    var _images$currentImageI = images[currentImageIndex],
      name = _images$currentImageI.name,
      src = _images$currentImageI.src;
    return ___EmotionJSX(Dialog, {
      title: name,
      onClose: function onClose() {
        return setCurrentImageIndex();
      },
      size: "large"
    }, ___EmotionJSX(DialogContainerStyles, null, ___EmotionJSX(ArrowStyles, {
      style: {
        left: isMobile ? '8px' : '0',
        visibility: currentImageIndex > 0 ? 'inherit' : 'hidden'
      },
      onClick: function onClick() {
        return setCurrentImageIndex(function (index) {
          return index - 1;
        });
      }
    }, ___EmotionJSX(Icon, {
      type: "chevron-left",
      variant: "brand"
    })), ___EmotionJSX(CardContainerStyles, null, ___EmotionJSX(Card, {
      secondary: true
    }, ___EmotionJSX(VisualizationImagesArrowsContainer, null, ___EmotionJSX(VisualizationStyles, {
      src: src,
      alt: name
    })))), ___EmotionJSX(ArrowStyles, {
      style: {
        right: isMobile ? '8px' : '0',
        visibility: currentImageIndex < images.length - 1 ? 'inherit' : 'hidden'
      },
      onClick: function onClick() {
        return setCurrentImageIndex(function (index) {
          return index + 1;
        });
      }
    }, ___EmotionJSX(Icon, {
      type: "chevron-right",
      variant: "brand"
    }))), ___EmotionJSX(VisualizationImagesSelection, {
      style: {
        margin: isMobile ? theme.spacings.xxSmall + " auto 0" : ''
      }
    }, isMobile ? ___EmotionJSX(Pagination, {
      initialPage: currentImageIndex + 1,
      itemsPerPage: 1,
      totalItems: images.length,
      type: "mobile",
      onClickMobilePageItem: function onClickMobilePageItem(e) {
        return setCurrentImageIndex(e - 1);
      }
    }) : images.map(function (image, i) {
      return ___EmotionJSX(VisualizationImagesStyles, {
        key: i,
        onClick: function onClick() {
          return setCurrentImageIndex(i);
        },
        style: {
          backgroundImage: "url(" + image.src + ")",
          border: currentImageIndex === i ? "2px solid " + theme.colors.brand40 : "2px solid " + theme.colors.shade20
        }
      });
    })));
  };
  var renderInputImage = function renderInputImage() {
    return ___EmotionJSX(InputImageContainer, null, ___EmotionJSX(LeftSideContainer, null, ___EmotionJSX(IconContainer, null, ___EmotionJSX(Icon, {
      type: "image",
      secondary: true
    })), ___EmotionJSX("div", null, ___EmotionJSX(Text, {
      size: "t2",
      semibold: true,
      display: "flex"
    }, allowMultipleImages && !title && "Adicione at\xE9 " + maxFiles + " imagens \xE0 sua d\xFAvida (opcional)", !allowMultipleImages && !title && "Adicione uma imagem \xE0 sua d\xFAvida (opcional)", title && title), ___EmotionJSX(Text, {
      size: "t3",
      secondary: true
    }, "Imagens " + extractFormatsText(acceptedFormats) + " \n              de at\xE9 " + maxFileSize + " MB"))), ___EmotionJSX(Button, {
      dataTestId: dataTestId + "-button",
      secondary: true,
      onClick: handleClick,
      size: isMobile ? 'large' : 'medium'
    }, ___EmotionJSX(Text, {
      size: "t2",
      bold: true,
      alignment: "center",
      element: "span",
      variant: "brand"
    }, allowMultipleImages ? 'Adicionar imagens' : 'Adicionar imagem')));
  };
  var renderImages = function renderImages() {
    return ___EmotionJSX(ImagesContainer, null, allowMultipleImages && images.length < maxFiles && !isDesktop && ___EmotionJSX(AddMoreImagesStyles, {
      onClick: handleClick
    }, ___EmotionJSX(Icon, {
      type: "plus",
      dimmed: true,
      size: "big"
    })), images.map(function (image, i) {
      return ___EmotionJSX(ImageStylesContainer, {
        key: i
      }, ___EmotionJSX(ImageStyles, {
        style: {
          backgroundImage: "url(" + image.src + ")"
        },
        onClick: function onClick() {
          return openVisualization(i);
        }
      }), isDesktop ? ___EmotionJSX(Tooltip, {
        title: "Apagar imagem",
        position: "top"
      }, ___EmotionJSX(RemoveImageStyles, {
        id: "remove-image-button",
        onClick: function onClick(e) {
          return removeImage(e, i);
        }
      }, ___EmotionJSX(Icon, {
        type: "cancel",
        variant: "brand"
      }))) : ___EmotionJSX(RemoveImageStyles, {
        style: {
          opacity: '1',
          zIndex: '3'
        },
        onClick: function onClick(e) {
          return removeImage(e, i);
        }
      }, ___EmotionJSX(Icon, {
        type: "cancel",
        variant: "brand"
      })));
    }), allowMultipleImages && images.length < maxFiles && isDesktop && ___EmotionJSX(AddMoreImagesStyles, {
      onClick: handleClick
    }, ___EmotionJSX(Icon, {
      type: "Plus",
      dimmed: true,
      size: "big"
    })));
  };
  return ___EmotionJSX(React.Fragment, null, error && ___EmotionJSX(Alert, {
    title: error.title,
    primaryButtonText: "Fechar",
    onPrimaryClick: function onPrimaryClick() {
      return setError();
    },
    onClose: function onClose() {
      return setError();
    },
    secondaryButtonText: "",
    variant: "negative"
  }, ___EmotionJSX("span", {
    style: {
      minWidth: '250px'
    }
  }, error.message)), ___EmotionJSX(InputFileHiddenStyles, {
    "data-test-id": dataTestId,
    type: "file",
    tabIndex: "-1",
    ref: function ref(node) {
      inputFileRef.current = node;
    },
    onChange: function onChange() {
      if (inputFileRef != null && inputFileRef.current) {
        var files = inputFileRef.current.files;
        addImage(files);
      }
    },
    multiple: allowMultipleImages
  }), currentImageIndex !== undefined && renderVisualizationDialog(), images.length === 0 ? renderInputImage() : renderImages());
};
InputImage.propTypes = {
  dataTestId: PropTypes.string,
  maxFileSize: PropTypes.number,
  maxFileSizeErrorText: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string,
  allowMultipleImages: PropTypes.bool,
  acceptedFormats: PropTypes.arrayOf(string),
  acceptedFormatsErrorText: PropTypes.string,
  maxFiles: PropTypes.number,
  maxFilesErrorText: PropTypes.string
};
InputImage.defaultProps = {
  maxFileSize: 25,
  allowMultipleImages: false,
  acceptedFormats: ['jpg', 'jpeg', 'png'],
  maxFiles: 5
};
export default InputImage;